import PageContainer from 'components/common/PageContainer/PageContainer';
import SettingHeader from 'components/Settings/Components/SettingHeader/settingHeader';
import { settingsConfig } from 'components/Settings/settingsConfig';
import { useFullStoryPageView } from 'hooks/useFullstoryPageView';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import { TagsCreate } from 'components/Settings/Components/Tags/components/tagsCreate';

export const TagsCreatePage = () => {
    useFullStoryPageView({ pageName: settingsConfig.tagsNew.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <SettingHeader title={settingsConfig.tagsNew.title} subTitle={'Add & edit Tags'} isBackArrow={true} />
            </HeaderWrapper>
            <MainContent>
                <TagsCreate />
            </MainContent>
        </PageContainer>
    );
};
